(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.mobileMenu();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }

    mobileMenu() {
      const menuButton = this.header.querySelector('.header__menu-toggle-button');
      const menu = this.header.querySelector('.header__main-menu');
      const closeButton = this.header.querySelector('.header__menu-close');
      const html = document.documentElement;

      menuButton.addEventListener('click', () => {
        menu.classList.toggle('is-active');
        html.classList.toggle('overflow-hidden');
      });

      closeButton.addEventListener('click', () => {
        menu.classList.remove('is-active');
        html.classList.remove('overflow-hidden');
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-event-schedule"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Add CSS for animations
    const style = document.createElement('style');
    style.innerHTML = `
            .event-schedule__list-description p {
                overflow: hidden;
            }
            .event-schedule__list-description p.hidden-paragraph {
                max-height: 0;
                opacity: 0;
                margin-top: 0;
                margin-bottom: 0;
            }
            .event-schedule__list-description p:not(.hidden-paragraph) {
                max-height: 1000px; /* Large enough to fit any paragraph */
                opacity: 1;
            }
        `;
    document.head.appendChild(style);

    // Function to show/hide paragraphs after the 3rd one with animation
    function manageParagraphsVisibility(descriptionElement, showAll) {
      const paragraphs = descriptionElement.querySelectorAll('p');
      paragraphs.forEach((p, index) => {
        if (index >= 3) {
          if (showAll) {
            p.classList.remove('hidden-paragraph');
          } else {
            p.classList.add('hidden-paragraph');
          }
        }
      });
    }

    // Calculate the highest height of all descriptions with all paragraphs visible in active state
    function calculateMaxDescriptionHeight() {
      let maxHeight = 0;

      // Create a temporary wrapper with position absolute to measure without affecting layout
      const tempWrapper = document.createElement('div');
      tempWrapper.style.position = 'absolute';
      tempWrapper.style.visibility = 'hidden';
      tempWrapper.style.left = '-9999px';
      tempWrapper.style.width = document.querySelector('.event-schedule__list-description').offsetWidth + 'px';
      document.body.appendChild(tempWrapper);

      // Clone and measure each description in a fully active state
      document.querySelectorAll('.event-schedule__list-description').forEach((description) => {
        // Clone the description to avoid modifying the original
        const clone = description.cloneNode(true);

        // Add active state styling
        clone.style.transition = 'none'; // Disable transitions for accurate measurement
        tempWrapper.appendChild(clone);

        // Show all paragraphs
        clone.querySelectorAll('p').forEach((p) => {
          p.classList.remove('hidden-paragraph');
          p.style.maxHeight = 'none';
          p.style.opacity = '1';
          p.style.margin = ''; // Use default margins
        });

        // Ensure everything is displayed properly
        clone.style.display = 'block';
        clone.style.height = 'auto';
        clone.style.opacity = '1';

        // Force browser to apply styles before measuring
        void clone.offsetHeight;

        // Measure height
        const height = clone.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }

        // Remove the clone
        tempWrapper.removeChild(clone);
      });

      // Remove the temporary wrapper
      document.body.removeChild(tempWrapper);

      return maxHeight + 5; // Add a small buffer to prevent text cutoff
    }

    // Initialize all descriptions (hide paragraphs after 3rd except for active)
    document.querySelectorAll('.event-schedule__list-description').forEach((description) => {
      const isActive = description.closest('.event-schedule__list').classList.contains('is-active');
      manageParagraphsVisibility(description, isActive);
    });

    // For desktop view, set min-height to ensure consistent heights
    if (window.innerWidth >= 990) {
      // Calculate the max height after initial setup
      setTimeout(() => {
        const maxHeight = calculateMaxDescriptionHeight();
        document.querySelectorAll('.event-schedule__list-description').forEach((description) => {
          description.style.height = maxHeight + 'px';
        });
      }, 200); // Increased delay to ensure all elements are properly rendered
    }

    if (window.innerWidth < 990) {
      document.querySelectorAll('.event-schedule__list-title').forEach((title) => {
        title.addEventListener('click', function () {
          // First, close all other items
          document.querySelectorAll('.event-schedule__list-title').forEach((otherTitle) => {
            if (otherTitle !== this) {
              otherTitle.nextElementSibling.ariaHidden = 'true';
              otherTitle.closest('.event-schedule__list').classList.remove('is-active');
              // Truncate description in closed items
              const descEl = otherTitle
                .closest('.event-schedule__list')
                .querySelector('.event-schedule__list-description');
              manageParagraphsVisibility(descEl, false);
            }
          });

          // Then toggle the clicked item
          const content = this.nextElementSibling;
          const isClosed = content.ariaHidden === 'true';
          content.ariaHidden = isClosed ? 'false' : 'true';
          const listEl = this.closest('.event-schedule__list');
          listEl.classList.toggle('is-active');

          // Show all paragraphs if active, otherwise truncate
          const descEl = listEl.querySelector('.event-schedule__list-description');
          manageParagraphsVisibility(descEl, listEl.classList.contains('is-active'));
        });
      });
    } else {
      document.querySelectorAll('.event-schedule__list').forEach((list) => {
        list.addEventListener('mouseenter', function () {
          // Remove is-active class from all items
          document.querySelectorAll('.event-schedule__list').forEach((otherList) => {
            otherList.classList.remove('is-active');
            otherList.querySelector('.event-schedule__list-content').setAttribute('aria-hidden', 'true');

            // Truncate description in inactive items
            const descEl = otherList.querySelector('.event-schedule__list-description');
            manageParagraphsVisibility(descEl, false);
          });

          // Add is-active class to current item
          this.classList.add('is-active');
          this.querySelector('.event-schedule__list-content').setAttribute('aria-hidden', 'false');

          // Show all paragraphs for active description
          const descEl = this.querySelector('.event-schedule__list-description');
          manageParagraphsVisibility(descEl, true);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
